import React from "react";
import ReactDOM from "react-dom/client";
import { router } from "./routes/Routes.jsx";
import "./styles/global.css";
import { RouterProvider } from "react-router-dom";
import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 0.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: import.meta.env.MODE === "production" ? 1.0 : 0.0,
    beforeSend(event) {
      const sensitiveKeys = [
        'studentName', 'oen', 'data'];
      if (event.request?.data && typeof event.request.data === 'object') {
        sensitiveKeys.forEach(k => {
          if (event.request.data[k] !== undefined) event.request.data[k] = '[Filtered]';
        });
      }
      return event;
    },
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
